import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import clone from 'clone';
import {
  Grid,
} from 'semantic-ui-react';
import AppForm from '../../components/AppForm';
import LoadImage from '../../components/LoadImage';

class LogoForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    logo: PropTypes.shape({
      key: PropTypes.string,
    }),
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static defaultValues = {
    label: '',
  }
  constructor(props) {
    super(props);
    const logo = Object.assign({}, LogoForm.defaultValues, props.logo || {});
    this.state = {
      logo,
      oriLogo: clone(logo),
      errMessages: [],
    };
    this.validation = {
      label: createRef(),
    };
  }
  componentWillReceiveProps(nextProps) {
    let logo = Object.assign({}, LogoForm.defaultValues, this.state.logo);
    let oriLogo = this.state.oriLogo;
    if (JSON.stringify(this.props.logo) !== JSON.stringify(nextProps.logo)) {
      logo = Object.assign(logo, nextProps.logo);
      oriLogo = clone(logo);
    }
    this.setState({
      logo,
      oriLogo,
    });
  }
  submit(url, opts) {
    return this.form.submit(url, opts);
  }
  handleSubmit = (event) => {
    event.preventDefault();
    const { logo } = this.state;
    logo.label = logo.label.trim();
    AppForm.validate(this.validation, logo)
      .then((validations) => {
        this.props.onSubmit(validations, logo);
      });
  }
  handleCheckChanges() {
    if (this.props.onChange) {
      this.props.onChange(true);
    }
  }
  handleInputChange = (event, { name, value }) => {
    const { logo } = this.state;
    let newValue = value;
    if (name === 'label') {
      newValue = value.replace(/[\\~#%&*{}/:<>?|"]/, '');
    }
    logo[name] = newValue;
    this.setState({ logo }, () => {
      this.handleCheckChanges();
    });
  }
  render() {
    return (
      <AppForm
        onSubmit={this.handleSubmit}
        error={this.state.errMessages.length > 0}
        ref={(ref) => { this.form = ref; }}
      >
        <Grid columns="equal" stackable doubling>
          <Grid.Row>
            <Grid.Column textAlign="center">
              <LoadImage
                wrapped
                picture={this.state.logo}
                pictureSize={100}
                extension="png"
              />
            </Grid.Column>
            <Grid.Column>
              <AppForm.Input
                label="Label"
                type="text"
                name="label"
                value={this.state.logo.label}
                onChange={this.handleInputChange}
                ref={this.validation.label}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </AppForm>
    );
  }
}

export default connect(
  LogoForm.mapStateToProps, null, null, { withRef: true },
)(LogoForm);



// WEBPACK FOOTER //
// ./src/containers/Logo/Form.jsx